import React from 'react';

const StoryHeader = () => (
  <div className='story-end-comment'>
    <i>
      <p>
        Si te gustó o tienes algún comentario, házmelo saber aquí 👉🏼{' '}
        <a mailto='elohinaguevara@gmail.com'>elohinaguevara@gmail.com</a>
      </p>
      <p>¡Gracias!</p>
    </i>
  </div>
);

export default StoryHeader;



// WEBPACK FOOTER //
// ./src/components/StoryEndComment.js